import { object, string, number } from "yup";
import { Fragments } from "requests";

export const getValidation = (
  miscellaneous: Fragments.StoredMiscellaneousGroup
) => {
  const nullableString = string().nullable();
  const positiveNumber = (message: string) =>
    number()
      .transform(value => (Number.isNaN(value) ? -1 : value))
      .positive(message)
      .nullable();

  const validationSchema = object({
    catheterSize: nullableString,
    catheterLocation: nullableString,
    fluidType: nullableString,
    bloodPressureMonitoring: nullableString,
    fluidRate: positiveNumber("Fluid Rate must be positive."),
    fluidRateValue: positiveNumber("Fluid Rate value must be positive."),
    qualityOfSedation: nullableString,
    anesthesiaSystem: nullableString,
    bagSize: positiveNumber("Bag Size must be positive."),
    oxygenFlowRate: positiveNumber("Oxygen Flow Rate must be positive."),
    intubated: nullableString,
    endotrachealTubeSize: nullableString
  });

  return {
    validationSchema,
    defaultValues: {
      catheterSize: miscellaneous?.catheterSize || null,
      catheterLocation: miscellaneous?.catheterLocation || null,
      fluidType: miscellaneous?.fluidType || null,
      bloodPressureMonitoring: miscellaneous?.bloodPressureMonitoring || null,
      fluidRate:
        miscellaneous?.fluidRate == null ? null : `${miscellaneous.fluidRate}`,
      fluidRateValue:
        miscellaneous?.fluidRateValue == null
          ? null
          : `${miscellaneous.fluidRateValue}`,
      qualityOfSedation: miscellaneous?.qualityOfSedation || null,
      anesthesiaSystem: miscellaneous?.anesthesiaSystem || null,
      bagSize: miscellaneous?.bagSize || null,
      oxygenFlowRate: miscellaneous?.oxygenFlowRate || null,
      intubated:
        miscellaneous?.intubated === true
          ? "true"
          : miscellaneous?.intubated === false
          ? "false"
          : null,
      endotrachealTubeSize: miscellaneous?.endotrachealTubeSize || null
    }
  };
};
